import Miner, {MinerScenes} from "./index";

const chaosMiner = new Miner(MinerScenes.chaos)

export default chaosMiner